import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import { BOARDS_KEY_MAPPER_ENUM } from "@onesolution/constants";
import {
	authMiddleware,
	mondayBoards,
	userServices,
} from "@onesolution/middlewares";

import { mondayClient } from "@onesolution/monday/monday";
import { wrapWithUseQuery } from ".";

const getItemPageByValueQueryParams = z.object({
	boardId: z.nativeEnum(BOARDS_KEY_MAPPER_ENUM),
	columnIds: z.array(z.string()),
	skipAdminCheck: z.boolean().optional(),
	filter: z.array(
		z.object({
			column_id: z.string(),
			column_values: z.array(z.string()),
		}),
	),
});

const handler = createServerFn()
	.middleware([authMiddleware, mondayBoards, userServices])
	.validator(getItemPageByValueQueryParams)
	.handler(async ({ context, data }) => {
		const boardId = context.getBoard(data.boardId);

		const result = await mondayClient.query.itemPageByValues({
			...data,
			boardId,
			limit: 500,
		});

		const isAdmin = data.skipAdminCheck
			? false
			: context.user.roles.includes("OS-Admin");

		if (
			!isAdmin &&
			boardId === context.getBoard(BOARDS_KEY_MAPPER_ENUM.services) &&
			context.user.servicesIds?.length
		) {
			return result.items.filter((service) =>
				context.user.servicesIds!.includes(service.id),
			);
		}

		return result.items;
	});

export const getItemPageByValuesFromServer = wrapWithUseQuery(
	"itemsPagesByValues",
	handler,
);
